import { Box, Paper } from "@mui/material";
import { useState } from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import PayPage from "./componenets/pay/PayPage";
import TopBar from "./componenets/TopBar";
import HomePage from "./pages/HomePage";
import Layout from "./pages/Layout";

function App() {
  const [openPayPage, setOpenPayPage] = useState<boolean>(false);
  const [urlIframe, setUrlIframe] = useState<string>("");
  const JSXRouter = createBrowserRouter(
    createRoutesFromElements(
      <Route>
        <Route
          path="/"
          element={
            <HomePage
              setOpenPayPage={setOpenPayPage}
              openPayPage={openPayPage}
            />
          }
        ></Route>
        <Route
          path="/product/:productId"
          element={
            openPayPage ? (
              <PayPage
                urlIframe={urlIframe}
                setUrlIframe={setUrlIframe}
                setOpenPayPage={setOpenPayPage}
              />
            ) : (
              <Layout
                setOpenPayPage={setOpenPayPage}
                setUrlIframe={setUrlIframe}
              />
            )
          }
        />
      </Route>
    )
  );
  return (
    <Box width="100%" bgcolor="#421763">
      <Paper sx={{ maxWidth: 1440, alignItems: "center", m: "auto" }}>
        <TopBar />
        <RouterProvider router={JSXRouter} />
      </Paper>
    </Box>
  );
}

export default App;
